import {SET_VIDEOS, REMOVE_VIDEO, LOADIND_VIDEOS, SET_ERROR} from './types';

const initState = {
    videos: [],
    isFetching: false,
    isError: null,
};

export default function (state = initState, action) {
    switch (action.type) {
        case SET_VIDEOS:
            state = {
                isFetching: false,
                isError: null,
                videos: action.videos,
            };
            break;

        case REMOVE_VIDEO:
            state = {
                isFetching: false,
                isError: null,
                videos: [...state.videos.filter((a) => a.id !== action.id)],
            };
            break;

        case LOADIND_VIDEOS:
            state = {
                ...state,
                isFetching: action.isFetching,
            };
            break;

        case SET_ERROR:
            state = {
                ...state,
                isFetching: false,
                isError: action.isError,
            };
            break;
    }

    return state;
}
